// src/components/store/sections/gallery/GalleryV8CathedralwindowsSunsetAmber.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV8CathedralwindowsSunsetAmber(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={8}
      archKey="cathedral_windows"
      archLabel="Cathedral Arch Windows"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
